'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var name = '@wh/login-component';

// Actions
var FETCH_STARTED = exports.FETCH_STARTED = name + '/FETCH_STARTED';
var FETCH_FINISHED = exports.FETCH_FINISHED = name + '/FETCH_FINISHED';

var INIT_FORM = exports.INIT_FORM = name + '/INIT_FORM';
var FORM_INITIALIZED = exports.FORM_INITIALIZED = name + '/FORM_INITIALIZED';
var FORM_INITIALIZATION_FAILED = exports.FORM_INITIALIZATION_FAILED = name + '/FORM_INITIALIZATION_FAILED';

var LOGIN_BUTTON_CLICKED = exports.LOGIN_BUTTON_CLICKED = name + '/LOGIN_BUTTON_CLICKED';
var USER_LOGGED_IN = exports.USER_LOGGED_IN = name + '/USER_LOGGED_IN';
var USER_LOGIN_FAILED = exports.USER_LOGIN_FAILED = name + '/USER_LOGIN_FAILED';
var REGISTRATION_CLICKED = exports.REGISTRATION_CLICKED = name + '/REGISTRATION_CLICKED';
var ACCOUNT_RECOVERY_CLICKED = exports.ACCOUNT_RECOVERY_CLICKED = name + '/ACCOUNT_RECOVERY_CLICKED';

var CLEAR_PROPS = exports.CLEAR_PROPS = name + '/CLEAR_PROPS';

// Component to display
var NO_ELEMENT = exports.NO_ELEMENT = 'NO_ELEMENT';
var MESSAGE_ELEMENT = exports.MESSAGE_ELEMENT = 'MESSAGE_ELEMENT';
var LOGIN_FORM_ELEMENT = exports.LOGIN_FORM_ELEMENT = 'LOGIN_FORM_ELEMENT';

// Callback to call
var CALL_DISPLAY_LOGIN_FORM = exports.CALL_DISPLAY_LOGIN_FORM = 'CALL_DISPLAY_LOGIN_FORM';
var CALL_DISPLAY_MESSAGE = exports.CALL_DISPLAY_MESSAGE = 'CALL_DISPLAY_MESSAGE';

// Tracking events
var TRACKING_EVENT_NAME_LOGIN_OPENED = exports.TRACKING_EVENT_NAME_LOGIN_OPENED = 'event:loginOpened';
var TRACKING_EVENT_NAME_LOGIN_CLOSED = exports.TRACKING_EVENT_NAME_LOGIN_CLOSED = 'event:loginclosed';
var TRACKING_EVENT_NAME_INIT_ERROR = exports.TRACKING_EVENT_NAME_INIT_ERROR = 'event:logininitError';
var TRACKING_EVENT_NAME_ALREADY_LOGGED_IN = exports.TRACKING_EVENT_NAME_ALREADY_LOGGED_IN = 'event:loginalreadyLoggedIn';
var TRACKING_EVENT_NAME_LOGGED_IN = exports.TRACKING_EVENT_NAME_LOGGED_IN = 'event:logincomplete';
var TRACKING_EVENT_NAME_FORM_DISPLAYED = exports.TRACKING_EVENT_NAME_FORM_DISPLAYED = 'event:loginformdisplayed';
var TRACKING_EVENT_NAME_FORM_INTERACT = exports.TRACKING_EVENT_NAME_FORM_INTERACT = 'event:logininteract';
var TRACKING_EVENT_NAME_FORM_COMPLETE = exports.TRACKING_EVENT_NAME_FORM_COMPLETE = 'event:loginformcomplete';
var TRACKING_EVENT_NAME_FORM_SUBMIT = exports.TRACKING_EVENT_NAME_FORM_SUBMIT = 'event:loginsubmit';
var TRACKING_EVENT_NAME_FORM_ERROR_INLINE = exports.TRACKING_EVENT_NAME_FORM_ERROR_INLINE = 'event:loginerrorinline';
var TRACKING_EVENT_NAME_FORM_ERROR = exports.TRACKING_EVENT_NAME_FORM_ERROR = 'event:loginerror';

// Tracking actions
var EVENT_TO_TRACK_CUSTOM = exports.EVENT_TO_TRACK_CUSTOM = name + '/TRACKING_EVENT';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/constants.js
// module id = 32
// module chunks = 0